import React, { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

export default function OwnerAssistantPanel() {
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Hi Glazy! I can help you draft service descriptions, polish testimonials, plan promotions, write WhatsApp/email replies, or brainstorm new offerings. What shall we work on today?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const sessionId = useRef(localStorage.getItem("ayame_owner_assist") || crypto.randomUUID());
  const scrollRef = useRef(null);

  useEffect(() => { localStorage.setItem("ayame_owner_assist", sessionId.current); }, []);
  useEffect(() => { scrollRef.current?.scrollTo({ top: 9e9, behavior: "smooth" }); }, [messages, loading]);

  const send = async () => {
    if (!input.trim() || loading) return;
    const text = input.trim();
    setInput("");
    setMessages(m => [...m, { role: "user", content: text }]);
    setLoading(true);
    try {
      const r = await api.post("/owner/assistant", { session_id: sessionId.current, message: text });
      setMessages(m => [...m, { role: "assistant", content: r.data.reply }]);
    } catch {
      setMessages(m => [...m, { role: "assistant", content: "I'm having trouble right now. Please try again in a moment." }]);
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-white border border-[var(--border)] flex flex-col h-[560px]" data-testid="owner-assistant">
      <div className="px-5 py-4 border-b border-[var(--border)] bg-[var(--bg)] flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[var(--primary)] text-[var(--accent)] flex items-center justify-center">
          <i className="fa-solid fa-sparkles"></i>
        </div>
        <div>
          <p className="font-display text-xl leading-tight">AI Operations Assistant</p>
          <p className="text-[10px] uppercase tracking-widest text-[var(--muted)]">Powered by Claude · Helping Glazy run Ayame</p>
        </div>
      </div>
      <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 space-y-3 bg-[var(--bg)]">
        {messages.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[85%] px-4 py-2.5 text-sm leading-relaxed whitespace-pre-wrap ${
              m.role === "user"
                ? "bg-[var(--primary)] text-white rounded-2xl rounded-br-sm"
                : "bg-white border border-[var(--border)] text-[var(--text)] rounded-2xl rounded-bl-sm"
            }`} data-testid={`assist-msg-${i}`}>
              {m.content}
            </div>
          </div>
        ))}
        {loading && (
          <div className="flex justify-start">
            <div className="bg-white border border-[var(--border)] px-4 py-2.5 rounded-2xl rounded-bl-sm text-sm text-[var(--muted)]">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--accent)] animate-bounce mx-0.5" />
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--accent)] animate-bounce mx-0.5" style={{animationDelay:"0.15s"}} />
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--accent)] animate-bounce mx-0.5" style={{animationDelay:"0.3s"}} />
            </div>
          </div>
        )}
      </div>
      <form onSubmit={(e) => { e.preventDefault(); send(); }} className="p-3 border-t border-[var(--border)] bg-white flex gap-2">
        <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask Ayame's AI assistant..." disabled={loading}
          className="flex-1 px-4 py-2.5 bg-[var(--bg)] border border-[var(--border)] focus:outline-none focus:border-[var(--accent)] text-sm rounded-full" data-testid="assist-input" />
        <button type="submit" disabled={loading || !input.trim()} className="bg-[var(--accent)] text-white w-10 h-10 rounded-full disabled:opacity-50" data-testid="assist-send">
          <i className="fa-solid fa-paper-plane text-sm"></i>
        </button>
      </form>
    </div>
  );
}
